import React from 'react';

const SpanBr = (props) => {
  return (
    <React.Fragment>{props.text} {props.children}<br/></React.Fragment>
  );
};

export default SpanBr;
